import m from "mithril"
import Navbar from "../../component/navbar"
import LeftMenu from "../../component/sidebar_yoyic"
import Footer from "../../component/footer"

var mDcMasterProduct = require("../../models/dcmasterproduct")

function ListTable(self, cust) {
    return cust.map(function(u) {
        return m("tr", {}, [
            m('td', ''),
            m('td', u.kode),
            m('td', u.name),
            m('td', u.unit),
            m('td', u.price),
            m("td", [
                m("a", {class:"icon", strid: u._id,
                onclick: function(){
                    //console.log(this.getAttribute("strid"));
                    m.route.set('/dc/masterproduct/edit/:id', {id: u._id})
                }}, [
                    m("i", {class:"fas fa-edit"})
                ])
            ])
        ])
    })
}

var DcMasterProduct = {
    oninit: function(vnode){
        mDcMasterProduct.loadList();
    },
    view: function() {
        let self = this;
        return m("div", [
          m("section", {class:"section"}, [
              m(Navbar)
          ]),
          m("section", {class:"section", style:"margin-top: -120px; "}, [
              m("div", {class:"columns"}, [
                  m("div", {class:"column is-one-fifth"}, [
                    m(LeftMenu, {title: "dcproduct"})
                  ]),
                  m("div", {class:"column"}, [
                      m("h1", {class:"title"}, " Master Product"),
                      m("div", {class:"field is-grouped"}, [
                          m("p", {class:"control"}, [
                              m("a", {class:"button is-link", href: "#!/dc/masterproduct/edit/new"}, "Add New")
                          ])
                      ]),
                      m("table", {class: "table is-fullwidth is-narrow is-hoverable"}, [
                        m("thead", [
                            m("tr", [
                                m("th", ""),
                                m("th", "Kode"),
                                m("th", "Name"),
                                m("th", "unit"),
                                m("th", "Price"),
                                m("th", "")
                            ])
                        ]),
                        m("tbody", [
                            ListTable(self, mDcMasterProduct.list)
                        ])
                    ])
                  ])
              ])
          ]),
          m("section", {class:"section"}, [
              m(Footer)
          ])
        ]);
      }
}
module.exports = DcMasterProduct;
